import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/parents")({
	component: ParentsLayout,
});

function ParentsLayout() {
	return <Outlet />;
}
